export default {
  evcs_equipment: {
    index_columns: {
      equipment_id: '设备编号'
    }
  }
}
